import { trackEvent } from './analyticsService';

export type SearchFailureSignal = 'zero_results' | 'abandoned' | 'exact_fallback';

export interface FailedSearchPayload {
  type: SearchFailureSignal;
  rawQuery: string;
  parsedTokens: Array<{ kind: string; label: string; neg?: boolean }>;
  resultCount: number;
}

export function logFailedSearch(signal: FailedSearchPayload): void {
  trackEvent('search_no_results', {
    signal_type: signal.type,
    raw_query: signal.rawQuery,
    parsed_tokens: JSON.stringify(signal.parsedTokens),
    result_count: signal.resultCount,
  });
}
